export const HOTEL_NAME = "Lodgix";
export const HOTEL_ADDRESS = "No. 10 U/Kwari, Ladanai Quarters, Hotoro, Kano";
export const HOTEL_PHONE = "07036313352";
export const HOTEL_EMAIL = "logix@mail.com";
export const HOTEL_MOTTO = "Your Hotel, in Hand";

